<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import { translations, current_lang } from '../stores.js';
    import { onMount } from 'svelte';

    $: online = false;
    $: offline = false;
    let mapUrl = "https://citynomadi.com/embed/route/62ef4a46db6f57d200c6dcbe25e8a698";
    
    async function checkMap(){
        let res = await fetch(mapUrl, {mode: 'no-cors', method: 'GET',headers: { "Content-Type": "text/plain" }}, )
        if (res) {
			return true;
		} else {
			throw new Error("offline");
		}
    }

    let promise = checkMap();
</script>
<SubPageHeader page_title={$translations["MAP"][$current_lang]} is_section_main_page={true}/>


{#await promise}
    <div class="content-container">
        {#if $current_lang == "FI"}
            <p>Ladataan...</p>
        {:else}
            <p>Loading...</p>
        {/if}
    </div>
{:then number}
    <div class="content-container full">
        <div class="map-container">
            <iframe id="festival-map" class="festival-map" src="https://citynomadi.com/embed/route/62ef4a46db6f57d200c6dcbe25e8a698" width="500" height="500" frameborder="0">Your browser does not support iframes.</iframe>
        </div>
    </div>
{:catch error}
    <div class="content-container">
        {#if $current_lang == "FI"}
            <p>Kartan lataaminen ei onnistunut. Ongelma voi johtua siitä, että laitteesi ei saa yhteyttä verkkoon. Jos näet tämän virheilmoituksen vielä yhteyden palauduttua, voit koittaa sulkea sovelluksen ja käynnistää sen uudelleen.</p>
        {:else}
            <p>Could not load map. Your device may be offline. If your connection has been restored and you still see this error, you can try restarting the app.</p>
        {/if}
    </div>
{/await}

<style>
    .content-container{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .map-container{
        height: 100%;
        width: 100%;
    }
    .map-container iframe{
        width: 100%;
        height: 100%;
        display: block;
    }
</style>